// @ts-nocheck
import * as keyCodeApi from '../api/keyCodeApi';
import type { DisableKeysParams } from '../api/keyCodeApi';
import actionTypes from '../constants/actionTypes';

//----------------------------------------------------------------------
// Search
export function searchCode({
  code,
  filters,
  _scopes,
  _sort,
  _order,
  _page,
  _limit,
}) {
  return keyCodeApi.searchCode({
    code,
    filters,
    _scopes,
    _sort,
    _order,
    _page,
    _limit,
  });
}

export function searchCodes({
  codesText,
  filters,
  _scopes,
  _sort,
  _order,
  _page,
  _limit,
}) {
  return keyCodeApi.searchCodes({
    codesText,
    filters,
    _scopes,
    _sort,
    _order,
    _page,
    _limit,
  });
}

export function searchTag({
  tag,
  filters,
  _scopes,
  _sort,
  _order,
  _page,
  _limit,
}) {
  return keyCodeApi.searchTag({
    tag,
    filters,
    _scopes,
    _sort,
    _order,
    _page,
    _limit,
  });
}

export function getCodeStatusHistory(id) {
  return keyCodeApi.getCodeStatusHistory(id);
}

//----------------------------------------------------------------------
// ACTIVATED
export function getActivatedTransactionById(id) {
  return keyCodeApi.getActivatedTransactionById(id);
}

export function loadActivatedTransactions(params) {
  return keyCodeApi.getActivatedTransactions(params);
}

export function uploadActivations(record) {
  return keyCodeApi.uploadActivations(record);
}

export function loadActivatedTransactionSkus(params) {
  const { id, ...rest } = params;
  return keyCodeApi.loadActivatedTransactionSkus(id, rest);
}

export function exportActivatedTransactionData(filters, scopes) {
  return keyCodeApi.exportActivatedTransactionData(filters, scopes);
}

//----------------------------------------------------------------------
// SOLD
export function getSoldTransactionById(id) {
  return keyCodeApi.getSoldTransactionById(id);
}

export function loadSoldTransactions(params) {
  return keyCodeApi.getSoldTransactions(params);
}

export function uploadSold(record) {
  return keyCodeApi.uploadSold(record);
}
export function loadSoldTransactionSkus(params) {
  const { id, ...rest } = params;
  return keyCodeApi.loadSoldTransactionSkus(id, rest);
}

export function clearSoldTransaction() {
  return function (dispatch) {
    dispatch({
      type: actionTypes.CLEAR_SOLD_TRANSACTION,
    });
  };
}

export function authoriseSoldTransaction(id) {
  return keyCodeApi.authoriseSoldTransaction(id);
}

export function exportSoldTransactionData(filters, scopes) {
  return keyCodeApi.exportSoldTransactionData(filters, scopes);
}

//----------------------------------------------------------------------
// MOVE
export function getMoveTransactionById(id) {
  return keyCodeApi.getMoveTransactionById(id);
}

export function loadMoveTransactions(params) {
  return keyCodeApi.getMoveTransactions(params);
}

export function clearMoveTransaction() {
  return function (dispatch) {
    dispatch({
      type: actionTypes.CLEAR_MOVE_TRANSACTION,
    });
  };
}

export function exportMoveTransactionData(filters, scopes) {
  return keyCodeApi.exportMoveTransactionData(filters, scopes);
}

//----------------------------------------------------------------------
// INGESTED
export function getIngestedTransactionById(id) {
  return keyCodeApi.getIngestedTransactionById(id);
}

export function removeIngestedKeys(id) {
  return keyCodeApi.removeIngestedKeys(id);
}

export function retryIngestedKeys(id) {
  return keyCodeApi.retryIngestedKeys(id);
}

export function loadIngestedTransactions(params) {
  return keyCodeApi.getIngestedTransactions(params);
}

export function clearImportTransaction(id) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.DELETE_IMPORT_TRANSACTION,
      id,
    });
  };
}

export function exportIngestedTransactionsData(filters, scopes) {
  return keyCodeApi.exportIngestedTransactionsData(filters, scopes);
}

//----------------------------------------------------------------------
// BULK INGESTED

export function getBulkIngestedTransactionById(id) {
  return keyCodeApi.getBulkIngestedTransactionById(id);
}

export function loadBulkIngestedTransactions(params) {
  return keyCodeApi.getBulkIngestedTransactions(params);
}
export function bulkUpload(record) {
  return keyCodeApi.bulkUpload(record);
}

export function exportBulkIngestedTransactionsData(filters, scopes) {
  return keyCodeApi.exportBulkIngestedTransactionsData(filters, scopes);
}

//----------------------------------------------------------------------
// DISABLE KEYS

/** @param {DisableKeysParams} params */
export function disableKeys(params: DisableKeysParams) {
  return keyCodeApi.disableKeys(params);
}

//----------------------------------------------------------------------
// MOVE

export function moveKeys({
  skuId,
  sourceKeyWorkflowId,
  destinationKeyPools,
  description,
}) {
  return keyCodeApi.moveKeys({
    skuId,
    sourceKeyWorkflowId,
    destinationKeyPools,
    description,
  });
}

export function splitFileIntoKeyPools({
  skuId,
  fileId,
  destinationKeyPools,
  description,
}) {
  return keyCodeApi.splitFileIntoKeyPools({
    skuId,
    fileId,
    destinationKeyPools,
    description,
  });
}

// ===================================
// Move keys between requests
export function moveKeysBetweenRequests({
  sourceKeyRequestId,
  destinationKeyRequestId,
  reason,
}) {
  return keyCodeApi.moveKeysBetweenRequests({
    sourceKeyRequestId,
    destinationKeyRequestId,
    reason,
  });
}
